<template>
  <div class="rb-ob-form rb-match-page rb-book-page">
    <header>
      <h1 class="rb-ob-title">{{ $t('intake.holdExpTitle') }}</h1>
    </header>

    <div class="rb-ob-status-panel">
      <p class="rb-match-outcome-body">{{ $t('intake.holdExpBody') }}</p>
    </div>

    <ul class="rb-book-summary" :aria-label="$t('intake.holdExpSummaryAria')">
      <li>
        <span class="rb-book-summary-k">{{ $t('intake.holdExpPrevTime') }}</span>
        <span class="rb-book-summary-v">{{ summaryTime }}</span>
      </li>
      <li>
        <span class="rb-book-summary-k">{{ $t('intake.holdExpPayStatusLabel') }}</span>
        <span class="rb-book-summary-v">{{ $t('intake.holdExpPayStatus') }}</span>
      </li>
    </ul>

    <div class="rb-ob-actions">
      <button class="rb-ob-submit" type="button" @click="pickOther">
        {{ $t('intake.holdExpPickOther') }}
      </button>
      <p class="rb-ob-status" role="status" aria-live="polite"></p>
      <div class="rb-ob-trust">
        <p>{{ $t('intake.trustPath') }}</p>
        <p>{{ $t('authUi.familyNote') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {loadIntake, saveIntake} from '@/intake/intakeState'
import {bookingSummary} from '@/intake/bookingSummary'
import {
  isMatchmakingV2ApiEnabled,
  releaseHold,
} from '@/intake/sandboxMatchApi'
import {loadMatchSession, saveMatchSession} from '@/intake/sandboxMatchSession'

export default {
  name: 'MatchHoldExpiredStep',
  computed: {
    summaryTime() {
      const draft = loadIntake()
      const session = loadMatchSession() || {}
      return bookingSummary(draft, session, this.$i18n.locale, isMatchmakingV2ApiEnabled())
    },
  },
  created() {
    saveIntake({holdStartedAt: ''})
    const session = loadMatchSession() || {}
    if (isMatchmakingV2ApiEnabled() && session.holdId) {
      releaseHold(session.holdId).catch(() => null).finally(() => {
        saveMatchSession({
          holdId: null,
          holdExpiresAt: null,
          holdIdempotencyKey: null,
        })
      })
    } else {
      saveMatchSession({
        holdId: null,
        holdExpiresAt: null,
        holdIdempotencyKey: null,
      })
    }
  },
  methods: {
    pickOther() {
      const draft = loadIntake()
      if (!draft.therapistId && isMatchmakingV2ApiEnabled()) {
        return this.$router.push({name: 'intakeMatching', params: {lang: this.$route.params.lang || 'fa'}})
      }
      this.$router.push({
        name: 'intakeSlots',
        params: {
          lang: this.$route.params.lang || 'fa',
          therapistId: draft.therapistId || 't1',
        },
      })
    },
  },
}
</script>
